import React from "react";
import { Spinner } from "./ui";

/** The inline spinner pages show while their first request is in flight. */
const Loader = () => (
  <div className="flex items-center justify-center gap-3 py-10">
    <Spinner className="h-7 w-7 text-red-500 dark:text-orange-400" />
    <span className="text-sm font-semibold text-gray-500 dark:text-slate-400">Loading…</span>
  </div>
);

export default Loader;
